module.exports = __webpack_public_path__ + "5.0.2/img/preview_app.a7142771.png";